import React from 'react'
import Loader from '@/components/content/Loader'
import { createRoot, Root } from 'react-dom/client'

const LOADER_ID = 'moms-loader'

class MLoaderAction {
  root: Root | null = null

  private hideTimer: ReturnType<typeof setTimeout> | undefined

  constructor() {
    const $wrapper = document.getElementById(LOADER_ID)
    if (!$wrapper) return

    this.root = createRoot($wrapper)
  }

  hide = () => {
    if (this.root) {
      // 500ms 로딩 제거 지연 (너무 빠른 api 응답일 경우 사용자가 인지하기 어려움)
      clearTimeout(this.hideTimer)
      this.hideTimer = setTimeout(() => this.root?.render(null), 500)
    }
  }

  show = () => {
    if (this.root) {
      // 앞선 응답이 예약한 제거가 뒤이은 요청의 로더를 지우지 않도록 취소한다 (연속 요청 중 화면이 조작 가능해진다).
      clearTimeout(this.hideTimer)
      this.root.render(<Loader dimmed position="fixed-center" />)
    }
  }
}

const MLoader = new MLoaderAction()
export default MLoader
